"use client";
import dynamic from "next/dynamic";
import Delayed from "@/components/Delayed";
import { useSceneContext } from "@/contexts/SceneContext";

const AboutImage = dynamic(() => import("@/components/3D/Scenes/AboutImage"), {
  ssr: false,
});

const AboutImageWrapper = () => {
  const { webGLAvailable } = useSceneContext();
  return (
    <div
      id="about-image"
      className={"md:col-span-6 lg:col-span-5"}>
      <div className="aspect-[2048/1536] max-md:~-mx-5/12 md:aspect-[1536/2048] md:~-ml-5/12">
        <Delayed waitBeforeShow={500}>
          {webGLAvailable ? (
            <AboutImage />
          ) : (
            <picture data-webgl-fallback="portrait">
              <source
                media="(min-width: 768px)"
                srcSet="/photos/yves-about.webp"
              />
              {/* eslint-disable-next-line @next/next/no-img-element -- existing responsive portrait, no WebGL needed */}
              <img
                src="/photos/yves-about2.webp"
                alt="Yves Torres"
                className="size-full object-cover"
              />
            </picture>
          )}
        </Delayed>
      </div>
    </div>
  );
};

AboutImageWrapper.displayName = "AboutImageWrapper";

export default AboutImageWrapper;
